import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FaHome, FaCalendarAlt, FaLaptopCode, FaRegBuilding } from "react-icons/fa";
import "../Styles/Services.css";
import IntlMessages from "../../../intl/IntlMessages";
import { Building, MessageCircleHeartIcon } from "lucide-react";
import { FiMessageCircle } from "react-icons/fi";

const Services = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll(".service-card").forEach((card) => {
      observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);

  const services = [
    {
      title: <IntlMessages id="realEstate.services" />,
      description: <IntlMessages id="realEstate.completeSolutions" />,
      icon: <FaHome />,
      features: [
        <IntlMessages id="realEstate.transactions" />,
        <IntlMessages id="content.realEstateManagement" />,
        <IntlMessages id="realEstate.strategicInvestments" />,
        <IntlMessages id="expertise.propertySearch" />,
        <IntlMessages id="realEstate.technicalMaintenance" />,
      ],
      link: "/vision/immobilier",
    },
    {
      title: <IntlMessages id="eventManagement.title" />,
      description: <IntlMessages id="eventManagement.professionalEvents" />,
      icon: <FaCalendarAlt />,
      features: [
        <IntlMessages id="content.eventManagement" />,
        <IntlMessages id="vision.reportingAudit" />,
        <IntlMessages id="eventPlanning.decoration" />,
        <IntlMessages id="eventManagement.makeupBeauty" />,
        <IntlMessages id="eventPlanning.toolsEquipment" />,
      ],
      link: "/vision/évènementiel",
    },
    {
      title: <IntlMessages id="expertise.itServices" />,
      description: <IntlMessages id="it.customSolutions" />,
      icon: <FaLaptopCode />,
      features: [
        <IntlMessages id="content.digitalSolutions" />,
        <IntlMessages id="it.securityMaintenance" />,
        <IntlMessages id="it.systemIntegration" />,
        <IntlMessages id="it.networkTelecom" />,
      ],
      link: "/vision/informatique",
    },

    {
      title: <IntlMessages id="content.socialPlatform" />,
      description: <IntlMessages id="content.socialChatDescription" />,
      icon: <FiMessageCircle />,
      features: [
        <IntlMessages id="content.socialPlatform1" />,
        <IntlMessages id="content.socialPlatform2" />,
        <IntlMessages id="content.socialPlatform3" />,
      ],
      link: "/vision/socialPlatform",
    },
    {
      title: <IntlMessages id="content.btp" />,
      description: <IntlMessages id="it.customSolutions" />,
      icon: <FaRegBuilding />,
      features: [
        <IntlMessages id="content.btp1" />,
        <IntlMessages id="content.btp2" />,
        <IntlMessages id="content.btp3" />,
      ],
      link: "/vision/civilEngeneering",
    },
  ];

  return (
    <div className="services-container" id="services">
      <div className="services-header">
        <h2 className="section-title">
          <IntlMessages id="expertise.ourSkills" />
        </h2>
        <div className="title-underline" />
        <p className="section-subtitle">
          <IntlMessages id="expertise.professionalSolutions" />
        </p>
      </div>

      <div className="services-grid">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="service-icon">{service.icon}</div>
            <div className="service-content">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>
                    <span className="feature-dot"></span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
            <Link to={service.link} className="service-link">
              <IntlMessages id="process.discovery" />
              <span className="arrow">→</span>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
